'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import { ELanguage } from '../../Utils/constants.js';
import { ADR_TURBO_ONE, ADR_TURBO_TWO } from './const.js';

function getAdrTurbo(baseMsUrl, type, lang) {
    if (lang === void 0) { lang = ELanguage.VI; }
    return __awaiter(this, void 0, void 0, function () {
        var url, response, resData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    url = "".concat(baseMsUrl, "/").concat(type === 1 ? ADR_TURBO_ONE : ADR_TURBO_TWO);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: {
                                'Accept-Language': lang
                            }
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    resData = _a.sent();
                    return [2 /*return*/, resData];
                case 3: return [2 /*return*/];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}

export { getAdrTurbo };
//# sourceMappingURL=index.js.map
